/** FRE-142: dispatched whenever sync changed what the Library shows (tabs restored / uploaded / status changed). */
export const LIBRARY_CHANGED_EVENT = 'fretboard:library-changed';

/** Dispatched by authStore.logout; tabUploadSync listens to clear its retry timer. */
export const AUTH_LOGOUT_EVENT = 'fretboard:auth-logout';

/** FRE-224: dispatched whenever tab edits are created, updated, or marked seen. */
export const TAB_EDITS_CHANGED_EVENT = 'fretboard:tab-edits-changed';

